import { Navigate, Outlet } from 'react-router-dom'
import { paths } from '@/config/paths'
import { useRole } from '@/hooks/useRole'

const UserRoot = () => {
  const { hasAccess } = useRole()

  if (hasAccess('admin')) {
    return <Navigate to={paths.admin.dashboard.getHref()} replace />
  }

  return <Outlet />
}

export { UserRoot }
